module.exports = __webpack_public_path__ + "static/ganyu-banner-55e038d94ff0058d7c14114cd3c641d3.png";